const constants = {
    FINDING: 'FINDING',
    PENTEST: 'PENTEST',
    ASSET: 'ASSET',
    USER_DETAILS: 'USER_DETAILS',
    VULNERABILITY_ASSESSMENT:'VULNERABILITY_ASSESSMENT'
}
export default constants;
